// theme
import palette from '../theme/palette';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800],
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#D1E9FC',
    light: '#76B0F1',
    main: '#2065D1',
    dark: '#103996',
    darker: '#061B64',
    contrastText: '#fff',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800],
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
  },
  // GREEN
  {
    name: 'green',
    lighter: '#D5FFD5',
    light: '#A2FFA2',
    main: '#45FF45',
    dark: '#2DCC2D',
    darker: '#1A991A',
    contrastText: palette.light.grey[800],
  },
  // YELLOW
  {
    name: 'yellow',
    lighter: '#FFFFD5',
    light: '#FFFFA2',
    main: '#FFFF45',
    dark: '#CCCC2D',
    darker: '#99991A',
    contrastText: palette.light.grey[800],
  },
  // PINK
  {
    name: 'pink',
    lighter: '#FFD5E6',
    light: '#FFA2C3',
    main: '#FF459D',
    dark: '#CC2D5E',
    darker: '#991A35',
    contrastText: '#fff',
  },
  // TEAL
  {
    name: 'teal',
    lighter: '#D5FFFD',
    light: '#A2FFFF',
    main: '#45FFFF',
    dark: '#2DCCCC',
    darker: '#1A9999',
    contrastText: palette.light.grey[800],
  },
  // LAVENDER
  {
    name: 'lavender',
    lighter: '#E6D5FF',
    light: '#C3A2FF',
    main: '#9D45FF',
    dark: '#5E2DCC',
    darker: '#351A99',
    contrastText: '#fff',
  },
  // BROWN
  {
    name: 'brown',
    lighter: '#FFD5D5',
    light: '#FFA2A2',
    main: '#FF4545',
    dark: '#CC2D2D',
    darker: '#991A1A',
    contrastText: palette.light.grey[800],
  },
  // tm subs preset
  {
    name: 'tm',
    lighter: '#D5F8F2',
    light: '#80E8D9',
    main: '#00D1B2',
    dark: '#00A08A',
    darker: '#006658',
    contrastText: palette.light.grey[50],
  },
  // GOLD
  {
    name: 'gold',
    lighter: '#F3E2B5',
    light: '#E7C77A',
    main: '#D7A13C',
    dark: '#B8862F',
    darker: '#8F6622',
    contrastText: palette.light.grey[800],
  },
  {
    name: 'indigo',
    lighter: '#E3E4F5',
    light: '#A6A8D6',
    main: '#33356D',
    dark: '#24264D',
    darker: '#181A36',
    contrastText: palette.light.common.white,
  },
  // BLACK
  {
    name: 'black',
    lighter: '#D9D9D9',
    light: '#8C8C8C',
    main: '#212121',
    dark: '#141414',
    darker: '#000000',
    contrastText: palette.light.common.white,
  },
  // CORAL
  {
    name: 'coral',
    lighter: '#FBE4D8',
    light: '#F3B394',
    main: '#E98457',
    dark: '#B85E37',
    darker: '#7A3A1E',
    contrastText: palette.light.common.white,
  },
  // EMERALD
  {
    name: 'emerald',
    lighter: '#D8F5E0',
    light: '#8CE3A2',
    main: '#155C27',
    dark: '#26913F',
    darker: '#3BCB5F',
    contrastText: palette.light.common.white,
  },
  // NAVY
  {
    name: 'navy',
    lighter: '#D6DDEA',
    light: '#7488AC',
    main: '#102950',
    dark: '#0A1B39',
    darker: '#050E22',
    contrastText: palette.light.common.white,
  },
  // VIOLET
  {
    name: 'violet',
    lighter: '#E2D6F5',
    light: '#8A63C9',
    main: '#3D197D',
    dark: '#2B1159',
    darker: '#1A0838',
    contrastText: palette.light.common.white,
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const greenPreset = colorPresets[6];
export const yellowPreset = colorPresets[7];
export const pinkPreset = colorPresets[8];
export const tealPreset = colorPresets[9];
export const lavenderprest = colorPresets[10];
export const brownprest = colorPresets[11];
export const tmpreset = colorPresets[12];
export const goldpreset = colorPresets[13];
export const indigopreset = colorPresets[14];
export const blackpreset = colorPresets[15];
export const coralpreset = colorPresets[16];
export const emeraldpreset = colorPresets[17];
export const navypreset = colorPresets[18];
export const violetpreset = colorPresets[19];

export default function getColorPresets(presetsKey) {
  return {
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    default: defaultPreset,
    green: greenPreset,
    yellow: yellowPreset,
    pink: pinkPreset,
    teal: tealPreset,
    lavender: lavenderprest,
    brown: brownprest,
    tm: tmpreset,
    gold: goldpreset,
    indigo: indigopreset,
    black: blackpreset,
    coral: coralpreset,
    emerald: emeraldpreset,
    navy: navypreset,
    violet: violetpreset,
  }[presetsKey];
}
